import React from 'react';

import Dialog from '@mui/material/Dialog';
import { useMobileView } from '../../hooks/useMobileView';
import StripePayment from './StripePayment';

interface IPaymentPopup {
  open?: boolean;
  handlePopup?: () => void;
  refetch?: () => void;
}

const StripePaymentPopup = ({ open, handlePopup, refetch }: IPaymentPopup) => {
  const [mobileView] = useMobileView();

  return (
    <Dialog
      open={Boolean(open)}
      onClose={(event, reason) => {
        if (handlePopup && reason !== 'backdropClick') {
          handlePopup();
        }
      }}
      maxWidth={false}
      fullScreen={mobileView}
    >
      <StripePayment
        handleCancel={() => {
          if (handlePopup) {
            handlePopup();
          }
        }}
        handleComplete={() => {
          if (handlePopup) {
            handlePopup();
          }
          if (refetch) {
            refetch();
          }
        }}
      />
    </Dialog>
  );
};

export default StripePaymentPopup;
